import Button from '@codegouvfr/react-dsfr/Button';
import { cx } from '@codegouvfr/react-dsfr/fr/cx';
import Input from '@codegouvfr/react-dsfr/Input';
import { SegmentedControl } from '@codegouvfr/react-dsfr/SegmentedControl';
import clsx from 'clsx';
import type { FindSampleOptions } from 'maestro-shared/schema/Sample/FindSampleOptions';
import { useAppDispatch, useAppSelector } from 'src/hooks/useStore';
import useWindowSize from 'src/hooks/useWindowSize';
import { t } from 'src/i18n';
import { getSampleListExportURL } from 'src/services/sample.service';
import samplesSlice from 'src/store/reducers/samplesSlice';

interface Props {
  findSampleOptionsWithYear: Partial<FindSampleOptions>;
  changeFilter: (filters: Partial<FindSampleOptions>) => void;
  samplesCount?: number;
}

const SampleListHeader = ({
  findSampleOptionsWithYear,
  changeFilter,
  samplesCount
}: Props) => {
  const dispatch = useAppDispatch();
  const { isMobile } = useWindowSize();

  const { sampleListDisplay } = useAppSelector((state) => state.samples);

  const changeReference = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeFilter({
      reference: e.target.value
    });
  };

  return (
    <>
      <div className={clsx('d-flex-align-center')}>
        <div className={cx('fr-text--bold')}>
          {t('sample', { count: samplesCount })}
        </div>
        <Input
          iconId="fr-icon-search-line"
          hideLabel
          label="N° de prélèvement"
          nativeInputProps={{
            type: 'search',
            placeholder: 'N° de prélèvement',
            value: findSampleOptionsWithYear.reference ?? '',
            autoFocus: true,
            onChange: changeReference
          }}
          className={cx('fr-my-0', 'fr-ml-3w', 'fr-hidden', 'fr-unhidden-md')}
        />
      </div>
      {!isMobile && (
        <div>
          <SegmentedControl
            hideLegend
            legend="Légende"
            segments={[
              {
                label: 'Grille',
                iconId: 'fr-icon-layout-grid-line',
                nativeInputProps: {
                  checked: sampleListDisplay === 'cards',
                  onChange: () =>
                    dispatch(samplesSlice.actions.changeListDisplay('cards'))
                }
              },
              {
                label: 'Tableau',
                iconId: 'fr-icon-table-line',
                nativeInputProps: {
                  checked: sampleListDisplay === 'table',
                  onChange: () =>
                    dispatch(samplesSlice.actions.changeListDisplay('table'))
                }
              }
            ]}
            className={cx('fr-mr-3w')}
          />
          <Button
            iconId="fr-icon-file-download-line"
            priority="secondary"
            onClick={() =>
              window.open(
                getSampleListExportURL({
                  ...findSampleOptionsWithYear,
                  perPage: undefined,
                  page: undefined
                })
              )
            }
            title="Exporter"
            size={isMobile ? 'small' : 'medium'}
          >
            {isMobile ? undefined : 'Exporter'}
          </Button>
        </div>
      )}
      <div className={clsx(cx('fr-hidden-md', 'fr-pt-2w'))}>
        <Input
          iconId="fr-icon-search-line"
          hideLabel
          label="N° de prélèvement"
          nativeInputProps={{
            type: 'search',
            placeholder: 'N° de prélèvement',
            value: findSampleOptionsWithYear.reference ?? '',
            onChange: changeReference
          }}
        />
      </div>
    </>
  );
};

export default SampleListHeader;
